import { ImporterEvent } from './importer-event';
import { ImporterEventType } from './importer-event-type';

export class CompleteEvent implements ImporterEvent {
  type = ImporterEventType.Complete;
}
